
import React from 'react'

export const VideoIcon = (props) => {
    return (
        <span className={`icon-video`}>
            <svg width="28px" height="28px" viewBox="0 0 68 68" >
                <defs>
                    <path d="M0 0L48 0L48 48L0 48L0 0Z" id="path_1" />
                </defs>
                <g id="Group">
                    <path d="M0 34C0 15.2223 15.2223 0 34 0C52.7777 0 68 15.2223 68 34C68 52.7777 52.7777 68 34 68C15.2223 68 0 52.7777 0 34Z" id="Ellipse" fill="#00B0FF" fillOpacity="0.2" fillRule="evenodd" stroke="none" />
                    <g id="icons8-play" transform="translate(10 10)">
                        <path d="M0 0L48 0L48 48L0 48L0 0Z" id="Background" fill="#FFFFFF" fillOpacity="0" fillRule="evenodd" stroke="none" />
                        <g clipPath="url(#mask_1)">
                            <g id="surface815395" transform="translate(16 10)">
                                <path d="M0 0L0 28L22 14L0 0ZM4 7.28516L14.5508 14L4 20.7148L4 7.28516Z" id="Shape" fill="#00B0FF" fillRule="evenodd" stroke="none" />
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        </span>
    );
}
